import React from 'react';
import { useInView } from 'react-intersection-observer';
import { FaAward, FaUsers, FaHeart, FaRoad } from 'react-icons/fa';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const features = [
    {
      icon: <FaAward />,
      title: 'Premium Quality',
      description: 'Top-tier caravans equipped with modern amenities for your comfort',
    },
    {
      icon: <FaUsers />,
      title: 'Expert Team',
      description: 'Experienced drivers and support staff for a seamless journey',
    },
    {
      icon: <FaHeart />,
      title: 'Customer First',
      description: '500+ happy travelers with 4.5★ average rating',
    },
    {
      icon: <FaRoad />,
      title: 'Flexible Routes',
      description: 'Customizable itineraries across India\'s most scenic destinations',
    },
  ];

  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-custom">
        <div ref={ref} className="max-w-6xl mx-auto">
          {/* Header */}
          <div className={`text-center mb-12 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'}`}>
            <span className="text-accent-600 font-semibold text-sm uppercase tracking-wide">
              About Us
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-primary-800 mt-4">
              Making Caravan Holidays as Pleasurable as the 
              <span className="text-accent-600"> Vacation Itself</span>
            </h2>
          </div>

          {/* Content */}
          <div className={`space-y-6 mb-12 transition-all duration-700 delay-200 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <p className="text-lg text-primary-600 leading-relaxed text-center max-w-4xl mx-auto">
              Founded in 2016, <strong>WOW Caravans</strong> has been pioneering 
              the caravan travel experience in India. Based in Nagpur, we've transformed the 
              way families and adventure enthusiasts explore the incredible diversity of our nation.
            </p>

            <p className="text-lg text-primary-600 leading-relaxed text-center max-w-4xl mx-auto">
              Our mission is simple: turn your journey into an unforgettable adventure. 
              With fully-equipped caravans featuring kitchens, bathrooms, entertainment systems, 
              and comfortable sleeping arrangements, you carry your home wherever the road takes you.
            </p>
          </div>

          {/* Feature Cards */}
          <div className={`grid md:grid-cols-4 gap-6 transition-all duration-700 delay-400 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-2xl shadow-lg border border-primary-100 hover:shadow-xl transition-all hover:-translate-y-2 text-center"
              >
                <div className="text-4xl text-accent-500 mb-4 flex justify-center">
                  {feature.icon}
                </div>
                <h3 className="text-lg font-bold text-primary-800 mb-2">
                  {feature.title}
                </h3>
                <p className="text-primary-600 text-sm">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
